import { AxiosResponse } from "axios";
import { createSliceSaga } from "../saga-helper";
import {
  ManageDataSourceReducerAction,
  ManageDataSourceReducerName,
} from "./slice";
import { call, put } from "redux-saga/effects";
import {
  FacebookAuthService,
  GoogleAuthService,
  ManageDataSources,
} from "../../services/manageDataSourceServices";
import { DataSourceEnum } from "./type";

// SAGA FLOW EXAMPLE FOR FUTURE API INTEGRATION

const saga = createSliceSaga({
  name: "manage-data-source-saga-state",
  caseSagas: {
    *getDataSource() {
      try {
        yield put(ManageDataSourceReducerAction.setIsLoading(true));
        // Step-2: Calling the Service file API and setting the data in reducer
        const { data, status }: AxiosResponse = yield call(ManageDataSources);
        if (status === 200) {
          yield put(ManageDataSourceReducerAction.setDataSource(data.data));
        }
      } catch (error) {
        console.log("Error fetching users list");
      } finally {
        yield put(ManageDataSourceReducerAction.setIsLoading(false));
      }
    },
    *connectDataSource(action: any) {
      try {
        yield put(ManageDataSourceReducerAction.setIsLoading(true));

        const serviceMap: any = {
          [DataSourceEnum.Google]: GoogleAuthService,
          [DataSourceEnum.Facebook]: FacebookAuthService,
          [DataSourceEnum.Tiktok]: FacebookAuthService,
        };

        const service = serviceMap[action.payload];

        if (!service) {
          throw new Error("Invalid data source type");
        }

        const { status, data } = yield call(service);
        if (status === 200) {
          window.location.href = data.redirectUrl
          yield put(ManageDataSourceSagaAction.getDataSource());
        }
      } catch (error) {
        console.log("Error connecting Data Source", error);
      } finally {
        yield put(ManageDataSourceReducerAction.setIsLoading(false));
      }
    },
    *authGoogleLogin() {
      try {
        yield put(ManageDataSourceReducerAction.setIsLoading(true));
        const { status }: AxiosResponse = yield call(GoogleAuthService);
        if (status === 200) {
          yield call(ManageDataSourceSagaAction.getDataSource());
        }
      } catch (error) {
        console.log("Error authenicating google login");
      } finally {
        yield put(ManageDataSourceReducerAction.setIsLoading(false));
      }
    },
    *authFacebookLogin() {
      try {
        yield put(ManageDataSourceReducerAction.setIsLoading(true));
        const { status }: AxiosResponse = yield call(GoogleAuthService);
        if (status === 200) {
          yield call(ManageDataSourceSagaAction.getDataSource());
        }
      } catch (error) {
        console.log("Error authenicating meta login");
      } finally {
        yield put(ManageDataSourceReducerAction.setIsLoading(false));
      }
    },
    //TODO: Add later once confirmed
    // *authTiktokLogin() {
    //   try {
    //     yield put(ManageDataSourceReducerAction.setIsLoading(true));
    //     const { status }: AxiosResponse = yield call(TikTokAuthService);
    //     if (status === 200) {
    //       yield call(ManageDataSourceSagaAction.getDataSource());
    //     }
    //   } catch (error) {
    //     console.log("Error authenicating tiktok login");
    //   } finally {
    //     yield put(ManageDataSourceReducerAction.setIsLoading(false));
    //   }
    // },
  },
  sagaType: "takeEvery",
});

export const {
  actions: ManageDataSourceSagaAction,
  saga: ManageDataSourceSaga,
  name: ManageDataSourceSagaName,
} = saga;
